import { HeadCell, JOBS_STATUS, JOBS_TYPE } from 'models';
import { theme } from 'theme';

export const headCells: readonly HeadCell<JOBS_TYPE>[] = [
  {
    id: 'number',
    numeric: false,
    disablePadding: true,
    isSort: true,
    label: 'Job No.',
  },
  {
    id: 'start_datetime',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Date',
  },
  {
    id: 'address',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Short address',
  },
  {
    id: 'Sitter',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Sitter',
  },
  {
    id: 'total_fee',
    numeric: true,
    disablePadding: false,
    isSort: true,
    label: 'Total Fee',
  },
  {
    id: 'total',
    numeric: true,
    disablePadding: false,
    isSort: true,
    label: 'Total Charge',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Status',
  },
];

export const STATUS_COLOR = {
  [JOBS_STATUS.PENDING]: '#FFCC00',
  [JOBS_STATUS.STARTED]: theme.palette.secondary.main,
  [JOBS_STATUS.COMPLETED]: '#34C759',
  [JOBS_STATUS.CANCELED]: '#B6B6B6',
  [JOBS_STATUS.EXPIRED]: '#B6B6B6',
  [JOBS_STATUS.PENDING_COMPLETION]: '#FFCC00',
  [JOBS_STATUS.UPCOMING]: theme.palette.secondary.main,
  [JOBS_STATUS.UPCOMING_PAID]: theme.palette.secondary.main,
  [JOBS_STATUS.UPCOMING_INSUFFICIENT]: '#B6B6B6',
};
